<style lang="less" scoped>
@import '../../../style/common/variable';
.qyzslist{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;}
.first{display: flex;justify-content:space-between;width: 1160px;margin:auto;}
.second{display: flex;flex-direction: column;width: 680px;margin-right: 40px;margin-bottom: 40px;}
ul{list-style: none;margin: 0px;margin-left:-20px;margin-top: 0px;}
.imgNameIntroduce{text-align: left;}
.block{margin-top: 40px;}
.third{position: sticky; top: 0px;margin-top: 10px; display: flex;flex-direction: column;width: 350px;height:700px;text-align: left;
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 24px;color: rgb(25, 159, 248);}
.tuijianYD{margin-top: 20px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.ListYD{margin-left: -34px;margin-top: 0px;text-align: left;}
.hotnews{margin-top: 10px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: -2px;font-size: 18px;color: rgb(25, 159, 248);}
}
.hotNewsList{margin-left: -35px;margin-top: 0px;text-align: left;}}
@media screen and (max-width: @max-screen){
  .first {width: 100% !important; flex-direction: column; margin: 0;}
  .second { width: 100% !important; margin-right: 0; margin-bottom: 20px; transform: scale(0.95); transform-origin: top center;}
  .third {display: none;}
  ul {padding-left: 15px;}
  .third i { font-size: 18px !important; margin-left: 0 !important;}
  .tuijianYD {margin-top: 10px !important;
    > span {font-size: 16px !important;float: none !important;}
  }
  .hotnews {margin-top: 8px !important;
    > span {font-size: 16px !important;float: none !important;}
  }
  .block {margin-top: 20px !important;}
  .imgNameIntroduce {font-size: 14px;line-height: 1.4;}
  .second, .third {overflow-x: hidden;}
  .ListYD li {padding: 12px 0;min-height: 44px;}
}
</style>

<template>
  <div class="qyzslist">
    <div class="first">
      <div class="second">
        <ul>
          <li v-for="(item,index) in imgNameIntroducedata" :key="index" >
            <ImgNameIntroduce class="imgNameIntroduce" :imgNameIntroduce="item" @handleClick="goDetails"></ImgNameIntroduce>
          </li>
        </ul>
        <div class="block">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange(10)"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="countSum">
          </el-pagination>
        </div>
      </div>
      <div class="third">
        <div class="tuijianYD">
          <i class="iconfont icon-tubiao303" />
          <span>推荐公司 / Recommended Company</span>
        </div>
        <List class="ListYD" :List="readingdata" @clickListNews="goDetails"></List>
        <div class="hotnews">
          <i class="iconfont icon-zuirehotchunse" />
          <span>热门公司 / Hot Company</span>
        </div>
        <HotNewsList class="hotNewsList" :hotNewsList="hotItemdata" @clickHotNews="goDetails"></HotNewsList>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 企业展示列表页面
 */
import ImgNameIntroduce from '../assembly/ImgNameIntroduce.vue'
import List from '../assembly/List.vue'
import HotNewsList from '../assembly/HotNewsList.vue'
import arrayFun  from '../method/array.js'
export default {
  components: {
    ImgNameIntroduce,
    List,
    HotNewsList
  },
  name: '',
  data()
  {
    return {
      imgNameIntroducedata: [], //列表页数据
      num: null,
      items: [],
      moreLength: null,
      count: 10,
      pageSize: 10,
      currentPage: 1,
      countSum: null,
      catid: null,
      readingdata: [], // 推荐阅读数据
      hotItemdata: []  // 热门篇目数据
    }
  },
  created()
  {
    this.getdata()
    this.getList()
  },
  methods: {
    //获取企业展示推荐阅读和热门篇目数据
    getdata()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: 'id>0 and examine = 0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.readingdata = []
        let arrHot = []
        ret[0].data.forEach(item =>
        {
          if (item.company !== '')
          {
            this.readingdata.push({id: item.id, title: item.company})
            arrHot.push({id: item.id, title: item.company, hits: item.hits})
          }
        })
        this.hotItemdata = arrHot.sort(arrayFun.compareBtoS('hits'))
      })
    },
    // 获取企业展示的列表数据
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: 'id>0  and examine = 0', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.imgNameIntroducedata = []
        ret[0].data.forEach(item =>
        {
          this.imgNameIntroducedata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', name: item.company, introduce: item.introduce, guimo: '公司规模', size: item.size, description: '公司类型', type: item.type})
        })
      })
    },
    // 跳转到企业详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/CompanyShow', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/QyzsList.vue